import xhrCaller from "./xhr-caller";

export const xhrGlobalGetLogs = async (token, pi, pr) => {

	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Global/GetLogs?pi=${pi??0}&pr=${pr??200}`});
	return result;
}

export const xhrGlobalGetAudit = async (token, pi, pr) => {
	
	var result = await xhrCaller({ bearer: token, srv: 'api', action: `Global/GetAudit?pi=${pi??0}&pr=${pr??200}`});
	return result;
}

export const xhrGlobalGetModalities = async (token) => {

	var result = await xhrCaller({ bearer: token, srv: 'api', action: "Global/GetModalities"});
	return result;
}

export const xhrGlobalGetDicomTagAll = async (token) => {

	var result = await xhrCaller({ bearer: token, srv: 'api', action: "Global/GetDicomTagAll"});
	return result;
}

export const xhrGlobalGetGenderAll = async (token) => {

	var result = await xhrCaller({ bearer: token, srv: 'api', action: "Global/GetGenderAll"});
	return result;
}

export const xhrGlobalGetCountryAll = async (token) => {

	var result = await xhrCaller({ bearer: token, srv: 'api', action: "Global/GetCountryAll"});
	return result;
}
